<template>
    <v-chip
            :color="color"
            label
            class="pl-4"
            :small="small"
            :x-small="xSmall"
            dark
    >
        <v-icon left small :x-small="xSmall">{{this.icon}}</v-icon>
        {{value.name}}

        <slot name="postfix"></slot>
    </v-chip>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object
            },
            small: {
                    type: Boolean,
                    default: false
            },
            xSmall: {
                    type: Boolean,
                    default: false
            }
        },
        data() {
            return {
                map: [
                    {name: 'DRAFT', color: 'blue-grey', icon: 'far fa-circle'},
                    {name: 'PROVISIONAL', color: 'amber', icon: 'fas fa-adjust'},
                    {name: 'CONFIRMED', color: 'teal', icon: 'fas fa-check'},
                    {name: 'POSTPONED', color: 'orange', icon: 'far fa-pause-circle'},
                    {name: 'CANCELED', color: 'red darken-3', icon: 'fas fa-ban'},
                    {name: 'DELIVERED', color: 'light-blue darken-3', icon: 'fas fa-truck'},
                    {name: 'COMPLETE', color: 'light-green darken-3', icon: 'fas fa-check-double'},
                ]
            }
        },
        computed: {
            color() {
                return this.$_.find(this.map, {name: this.value.name}).color;
            },
            icon() {
                return this.$_.find(this.map, {name: this.value.name}).icon;
            }
        },
    }
</script>

<style scoped>

</style>